





















































import {Vue, Component, Watch} from 'vue-property-decorator';
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import dataProxy from "@/services/data-proxy.service";
import {formatDate, formatDateTime, formatPrice} from "@/utils/formatters";
import {ObracunStimulacijeModel} from "@/services/BackendProxies";
import moment from "moment";

declare const $: any;

@Component
export default class ObracunStimulacijeReport extends mixins(ComponentBaseMixin) {
    odDatuma;
    doDatuma;
    organizacionaJedinica = null;

    columns = [];

    options = {
        pagination: true,
        pageSize: 50,
        detailView: true,
        detailFormatter: this.detailFormatter,
        showExport: true,
        exportTypes: ['excel']
    }
    report = [];
    isBusy = false;
    isPrinting = false;
    select2Options = {
        minimumResultsForSearch: Infinity
    };
    pdfURL = null;

    async created() {
        this.columns = [
            {field: 'vozac', title: this.$i18n.t('vozac'), },
            {field: 'zona', title: this.$i18n.t('zona')},
            {field: 'iznosZaPredjeneKilometre', title: this.$i18n.t('iznosZaPredjeneKilometre'), width: 180, formatter: formatPrice, align: 'right'},
            {field: 'kategorija', title: this.$i18n.t('kategorija')},
            {field: 'iznosZaPrevezenuTezinu', title: this.$i18n.t('iznosZaPrevezenuTezinu'), width: 180, formatter: formatPrice, align: 'right'},
            {field: 'ukupanIznosStimulacije', title: this.$i18n.t('ukupanIznosStimulacije'), width: 180, formatter: formatPrice, align: 'right'},
        ];
        let month = moment().get('month');
        const year = moment().get('year');

        if (month > 2) {
            month = month - 1;
        }

        this.odDatuma = new Date(year, month - 1, 26, 2, 0, 0);
        this.doDatuma = new Date(year, month, 25, 2, 0, 0);
        this.load();
    }

    pretrazi() {
        if (this.odDatuma && this.doDatuma) {
            this.load();
        }
    }

    async stampaj() {
        try {
            this.isPrinting = true;
            const link = await this.loadData(() => dataProxy.vratiStampuObracunaStimulacijeVozacima(this.odDatuma, this.doDatuma, this.organizacionaJedinica))();
            this.pdfURL = `${link}?t=${new Date().getUTCMilliseconds()}`
        } finally {
            this.isPrinting = false;
        }
    }

    async load() {
        if (this.isBusy) return;
        this.isBusy = true;
        try {
            const report = await this.loadData(() => dataProxy.vratiObracunStimulacijeVozacima(this.odDatuma, this.doDatuma, this.organizacionaJedinica))();
            this.report = report;
        } catch (e) {

        } finally {
            this.isBusy = false;
        }

    }

    detailFormatter(ix: number, obracunStimulacije: ObracunStimulacijeModel, element) {
        const $detailsTable = $(`<table></table>`).bootstrapTable({
            columns: [
                {field: 'datum', title: this.$i18n.t('datum'), formatter: formatDate},
                {field: 'vozilo', title: this.$i18n.t('vozilo')},
                {field: 'bruto', title: this.$i18n.t('brutoTezina'), formatter: formatPrice, align: 'right'},
                {field: 'neto', title: this.$i18n.t('netoTezina'), formatter: formatPrice, align: 'right'},
                {field: 'kategorija', title: this.$i18n.t('kategorija')},
                {field: 'cenaPoToni', title: this.$i18n.t('stimulacijaPoToni'), formatter: formatPrice, align: 'right'},
                {field: 'iznosZaPrevezenuTezinu', title: this.$i18n.t('iznosZaPrevezenuTezinu'), formatter: formatPrice, align: 'right'},
                {field: 'razdaljina', title: this.$i18n.t('prevezenoKilometara'), formatter: formatPrice, align: 'right'},
                {field: 'zona', title: this.$i18n.t('zona'), },
                {field: 'cenaPoZoni', title: this.$i18n.t('stimulacijaPoZoni'), formatter: formatPrice, align: 'right'},
                {field: 'ukupanIznos', title: this.$i18n.t('ukupanIznosStimulacije'), formatter: formatPrice, align: 'right'},
            ],
            data: obracunStimulacije.specifikacija,
        });
        $detailsTable.appendTo(element);
    }
}
